import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, X } from "lucide-react";
import { useIntent, suggestPath, type IntentKind } from "@/lib/intent-router";

const MESSAGES: Record<IntentKind, { label: string; cta: string } | null> = {
  price: { label: "Vous cherchez un prix ?", cta: "Voir nos tarifs détaillés" },
  compare: { label: "Vous comparez les options ?", cta: "Voir le comparatif complet" },
  guide: { label: "Vous voulez comprendre ?", cta: "Lire le guide complet" },
  urgent: { label: "Vous avez un projet urgent ?", cta: "Voir les options express 24-48h" },
  local: { label: "Vous cherchez un prestataire local ?", cta: "Voir notre page ville" },
  brand: null,
  unknown: null,
};

/**
 * Bandeau contextuel affiché aux visiteurs entrants depuis une SERP.
 * Détecte l'intention via referrer/UTM et propose un raccourci.
 */
export const IntentBanner = () => {
  const intent = useIntent();
  const [dismissed, setDismissed] = useState(false);
  const message = MESSAGES[intent.kind];

  if (!message || dismissed) return null;
  if (intent.source !== "utm" && intent.source !== "referrer") return null;

  const path = suggestPath(intent);

  return (
    <div className="sticky top-0 z-40 border-b border-primary/20 bg-primary/95 text-primary-foreground backdrop-blur-md">
      <div className="container mx-auto flex items-center justify-between gap-3 px-4 py-2.5">
        <div className="flex min-w-0 items-center gap-3">
          <span className="hidden text-sm font-medium sm:inline">💡 {message.label}</span>
          <Link
            to={path}
            className="group inline-flex items-center gap-1.5 truncate rounded-lg bg-background/15 px-3 py-1.5 text-sm font-semibold transition hover:bg-background/25"
          >
            {message.cta}
            <ArrowRight className="size-3.5 transition group-hover:translate-x-0.5" />
          </Link>
        </div>
        <button
          onClick={() => setDismissed(true)}
          aria-label="Fermer"
          className="shrink-0 rounded-md p-1 hover:bg-background/15"
        >
          <X className="size-4" />
        </button>
      </div>
    </div>
  );
};
